import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
//import Reveal from 'reveal.js'
//import { readFile } from './utils/Utils'
//import marked from 'marked'
//import Experiment1 from './experiments/Experiment1'
//import Experiment2 from './experiments/Experiment2'
//import Experiment3 from './experiments/Experiment3'
import SlideShow from './slideshow/SlideShow'
//import List from './slideshow/List'
//import Links from './slideshow/Links'
import {readJson} from './utils/Utils'
import './reveal.js/css/reveal.css'
//import './reveal.js/css/theme/black.css'
import './reveal.js/lib/css/zenburn.css'
import './css/override.css'
import ThemeSelector from './components/ThemeSelector'

//const themes = ["black", "beige", "blood", "league", "moon", "night", "serif", "simple", "sky", "solarized", "white"]

export default class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: []
    }
    this.home = this.home.bind(this)
    this.show = this.show.bind(this)
  }
  componentDidMount() {
    const theme = localStorage.getItem('theme')||'black'
    this.setState({theme:theme},()=>{
      this.setTheme(this.state.theme)
      this.load('_.json')
    })
  }
  setTheme(name, cb) {
    if (name === 'beige')
      require('./reveal.js/css/theme/beige.css')
    if (name === 'blood')
      require('./reveal.js/css/theme/blood.css')
    if (name === 'league')
      require('./reveal.js/css/theme/league.css')
    if (name === 'moon')
      require('./reveal.js/css/theme/moon.css')
    if (name === 'night')
      require('./reveal.js/css/theme/night.css')
    if (name === 'serif')
      require('./reveal.js/css/theme/serif.css')
    if (name === 'simple')
      require('./reveal.js/css/theme/simple.css')
    if (name === 'sky')
      require('./reveal.js/css/theme/sky.css')
    if (name === 'solarized')
      require('./reveal.js/css/theme/solarized.css')
    if (name === 'white')
      require('./reveal.js/css/theme/white.css')
    if (name === 'black')
      require('./reveal.js/css/theme/black.css')
    if (typeof(cb)==='function') {
      cb()
    }
  }
  load(filePath) {
    if (typeof(filePath)==='string'&&filePath.length>0) {
      readJson(filePath, (data)=>{
        const list = data
        if (Array.isArray(list)&&list.length>0) {
          list.sort((a,b)=>b.id-a.id)
          this.setState({list:list})
        }
      })
    }
  }
  home() {
    /*<Links
      filePath="list.json"
      onClick={(filePath)=>{
        this.setState({filePath:filePath})
      }}
    />*/
    return (
      <div id="home">
        <h3>Notesify</h3>
        <div>
          <label>Change theme </label>
          <ThemeSelector />
        </div>
        <hr/>

        <div className="row">
          <div className="col">
            <h4>From me</h4>
            <ul>
              {
                this.state.list.filter(e=>e.from==='me').map((e,i)=>(
                  <li key={i}>
                    <i className="fas fa-angle-right" style={{marginRight: '5px'}}></i>
                    <Link to={`/${e.filePath}`}>
                      {e.name}
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>

          <div className="col">
            <h4>From around the web</h4>
            <ul>
              {
                this.state.list.filter(e=>e.from!=='me').map((e,i)=>(
                  <li key={i}>
                    <i className="fas fa-angle-right" style={{marginRight: '5px'}}></i>
                    <Link to={`/${e.filePath}`}>
                      {e.name}
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>

        </div>

        <div style={{height:'50px'}}></div>
      </div>
    )
  }
  show({ match }) {
    if (typeof(match)==='object'&&match!==null) {
      if (typeof(match.params)==='object'&&match.params!==null) {
        const filePath = match.params.filePath
        if (typeof(filePath)==='string' && filePath.length>0) {
          return (
            <SlideShow
              filePath={filePath}
              done={()=>{
                this.setState({filePath:undefined})
              }}
            />
          )
        }
      }
    }
    return (<div></div>)
  }
  render() {
    return (
      <div className="container">
        <link rel="stylesheet" type="css" href={`./reveal.js/css/theme/${this.state.theme}.css`} />
        {/*<Experiment1/>*/}
        {/*<Experiment2/>*/}
        {/*<Experiment3/>*/}

        <Router>
          <React.Fragment>
            {/*
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
            </ul>

            <hr/>
            */}

            <Route exact path="/" component={this.home}/>

            {
              Array.isArray(this.state.list)&&
              this.state.list.length>0&&
              <Route path="/:filePath" component={this.show}/>
            }
          </React.Fragment>
        </Router>

        {/*
          typeof(this.state.filePath)==='string'&&
          this.state.filePath.length>0&&
          <SlideShow
            filePath={this.state.filePath}
            done={()=>{
              this.setState({filePath:undefined})
            }}
          />
        }
        {
          this.state.filePath===undefined&&
          <List
            filePath="list.json"
            onClick={(filePath)=>{
              this.setState({filePath:filePath})
            }}
          />
        */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js